import { stripEventMeta } from "../../shared/activities";

export const ADVENTURE_TYPES = [
  { value: "camping", label: "Camping", emoji: "⛺", color: "#4A7C59" },
  { value: "festival", label: "Festival", emoji: "🎪", color: "#7B5EA7" },
  { value: "day-trip", label: "Day Trip", emoji: "🌞", color: "#4A90C4" },
  { value: "staycation", label: "Staycation", emoji: "🏠", color: "#E8834A" },
  { value: "holiday", label: "Holiday", emoji: "✈️", color: "#E05C5C" },
  { value: "social", label: "Social", emoji: "🍕", color: "#5C6B47" },
] as const;

export function getTypeConfig(type: string) {
  return ADVENTURE_TYPES.find((t) => t.value === type) ?? ADVENTURE_TYPES[0];
}

const EVENT_MARKER_PREFIX = "[kindred-event:";

export function buildEventAdventureMarker(eventId: string) {
  return `${EVENT_MARKER_PREFIX}${eventId}]`;
}

export function buildAdventureDescriptionFromEvent(description: string | null | undefined, eventId: string) {
  const cleanDescription = stripEventMeta(description);
  return cleanDescription
    ? `${cleanDescription}\n\n${buildEventAdventureMarker(eventId)}`
    : buildEventAdventureMarker(eventId);
}

export function extractEventIdFromAdventureDescription(description: string | null | undefined) {
  const match = (description ?? "").match(/\[kindred-event:([^\]]+)\]/);
  return match?.[1] ?? null;
}

export function stripAdventureMeta(description: string | null | undefined) {
  return (description ?? "")
    .replace(/\n*\[kindred-event:[^\]]+\]\s*$/g, "")
    .trim();
}

export function formatAgeRange(min: number | null, max: number | null): string {
  if (min === null && max === null) return "All ages welcome";
  if (min !== null && max !== null) return `Ages ${min}–${max} welcome`;
  if (min !== null) return `Ages ${min}+ welcome`;
  return `Ages up to ${max} welcome`;
}

export function formatDateRange(start: string, end: string | null): string {
  const s = new Date(start + "T00:00:00");
  const opts: Intl.DateTimeFormatOptions = { day: "numeric", month: "short", year: "numeric" };
  if (!end) return s.toLocaleDateString("en-GB", opts);
  const e = new Date(end + "T00:00:00");
  return `${s.toLocaleDateString("en-GB", opts)} – ${e.toLocaleDateString("en-GB", opts)}`;
}
